const projects = [
  {
    title: 'Mulch Supply Co.',
    description: 'Full business website for a landscaping supplies company. Clean design focused on product presentation and lead generation.',
    url: 'https://www.mulchsupply.com',
    tags: ['Web', 'Business Site', 'Lead Gen'],
    color: 'from-green-900/40 to-emerald-900/20',
  },
  {
    title: 'CR Big Bike Tours',
    description: 'Tourism and adventure website for a Costa Rica motorcycle tour operator. Mobile-first with booking inquiry flow.',
    url: 'https://www.crbigbiketours.com',
    tags: ['Web', 'Tourism', 'Mobile-first'],
    color: 'from-orange-900/40 to-amber-900/20',
  },
];

export default function Portfolio() {
  return (
    <section id="portfolio" className="py-28 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16">
          <span className="text-xs font-medium tracking-widest text-violet-400 uppercase">Work</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-3">Portfolio</h2>
          <p className="text-gray-400 mt-4 max-w-xl">
            A selection of projects I've built. More coming soon.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projects.map((p) => (
            <a key={p.title} href={p.url} target="_blank" rel="noreferrer"
              className="group block bg-white/[0.03] border border-white/[0.07] rounded-2xl overflow-hidden hover:border-violet-500/30 transition-all">

              {/* Preview area */}
              <div className={`h-48 bg-gradient-to-br ${p.color} flex items-center justify-center relative`}>
                <div className="absolute inset-0 flex items-center justify-center opacity-20 group-hover:opacity-30 transition-opacity">
                  <svg className="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1}
                      d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                </div>
                <span className="relative z-10 text-white/60 text-sm font-mono">{p.url.replace('https://', '')}</span>
              </div>

              <div className="p-8">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-white font-semibold text-lg">{p.title}</h3>
                  <svg className="w-4 h-4 text-gray-600 group-hover:text-violet-400 transition-colors flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed mb-5">{p.description}</p>
                <div className="flex flex-wrap gap-2">
                  {p.tags.map(tag => (
                    <span key={tag} className="text-xs text-gray-500 border border-white/[0.06] bg-white/[0.03] px-3 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
